import { call, put, takeLatest } from "redux-saga/effects";
import { mucThuTamThuSinhVienApi } from "../../../api/chung-tu/mucThuTamThuSinhVienApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";

import { rootActions } from "../../actions/rootActions";
import { IBienLaiThuCreateRequest } from "../../../model/request/bien-lai/IBienLaiThuCreateRequest";
import { bienLaiThuApi } from "../../../api/bien-lai/bienLaiThuApi";
import { sinhVienApi } from "../../../api/category/sinhVienApi";
import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";
import {
  eThuPhiTamThuActionIds,
  IThuPhiTamThuActionTypes,
} from "../../action-types/thu-phi-tam-thu/IThuPhiTamThuActionTypes";
import { IMucThuTamThuSinhVienSelectRequest } from "../../../model/request/chung-tu-tam-thu/IMucThuTamThuSinhVienSelectRequest";
import { IMucThuTamThuSinhVienViewModel } from "../../../model/respone/chung-tu-tam-thu/IMucThuTamThuSinhVienViewModel";

export function* thuPhiTamThuSaga(): any {
  yield takeLatest(eThuPhiTamThuActionIds.LOAD_MUC_THU_START, loadWorker);
  yield takeLatest(eThuPhiTamThuActionIds.ADD_NEW_TAB_BY_ID, addNewTabWorker);
  yield takeLatest(
    eThuPhiTamThuActionIds.CREATE_BIENLAITHU_START,
    createBienLaiWorker
  );
}

function* loadWorker(action: IThuPhiTamThuActionTypes): any {
  const request = action.payload as IMucThuTamThuSinhVienSelectRequest;
  const res: IBaseRespone = yield call(
    mucThuTamThuSinhVienApi.SelectBySinhVien,
    request
  );
  if (res.is_success) {
    const data: IMucThuTamThuSinhVienViewModel[] = res.data;
    yield put(
      rootActions.thuPhi.thuPhiTamThu.LOAD_MUC_THU_SUCCESS({
        request: request,
        data,
      })
    );
    yield put(
      rootActions.mucThu.mucthuTamThu.LOAD_MUC_THU_LOAD_SUCCESS({
        id_sv: request.id_sv,
        data: data,
      })
    );
  } else {
    yield put(
      rootActions.thuPhi.thuPhiTamThu.LOAD_MUC_THU_ERROR({
        request: request,
        data: res.message ?? "Có lỗi",
      })
    );
  }
}
function* addNewTabWorker(action: IThuPhiTamThuActionTypes): any {
  const request = action.payload as string;
  const res: IBaseRespone = yield call(sinhVienApi.SelectById, request);
  if (res.is_success) {
    const data: IStuHoSoSinhVienViewModel = res.data;
    yield put(rootActions.thuPhi.thuPhiTamThu.ADD_NEW_TAB(data));
  } else {
    yield put(
      rootActions.thuPhi.thuPhiTamThu.ADD_NEW_TAB_BY_ID_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* createBienLaiWorker(action: IThuPhiTamThuActionTypes): any {
  const request = action.payload as IBienLaiThuCreateRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.Create, request);
  if (res.is_success) {
    const data: number = res.data;
    yield put(
      rootActions.thuPhi.thuPhiTamThu.CREATE_BIENLAITHU_SUCCESS({
        request,
        data,
      })
    );
    yield put(
      rootActions.mucThu.mucthuTamThu.LOAD_MUC_THU_LOAD_START(request.id_sv)
    );
    yield put(
      rootActions.bienLai.bienLaiView.LOAD_START({
        hoc_ky: request.hoc_ky,
        nam_hoc: request.nam_hoc,
        id_sv: request.id_sv,
      })
    );
  } else {
    yield put(
      rootActions.thuPhi.thuPhiTamThu.CREATE_BIENLAITHU_ERROR({
        request,
        data: res.message ?? "Có lỗi",
      })
    );
  }
}
